import { __awaiter, __generator } from "tslib";
import * as yup from "yup";
export var getCreateFolderFields = function (_a) {
    var apiRef = _a.apiRef, _b = _a.hideFolderOptions, hideFolderOptions = _b === void 0 ? false : _b;
    return ({
        general: {
            type: "grouping",
            label: "",
            collaspable: false,
            fields: {
                name: {
                    label: "Name",
                    LabelProps: {
                        placement: "start",
                    },
                    FieldProps: {
                        type: "text",
                        placeholder: "",
                    },
                    schema: yup.string().required("Name is required"),
                    autoFocus: true,
                },
                parent_id: {
                    label: "Parent Folder",
                    LabelProps: {
                        placement: "start",
                    },
                    default: "/",
                    FieldProps: {
                        type: "singleSelect",
                        options: {
                            fetchedValueOptions: function (values) { return __awaiter(void 0, void 0, void 0, function () {
                                var defaultOptions, response;
                                var _a, _b;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            defaultOptions = hideFolderOptions
                                                ? []
                                                : [
                                                    {
                                                        value: "/",
                                                        label: "/",
                                                        caption: "Root",
                                                    },
                                                ];
                                            if (!apiRef.list)
                                                return [2 /*return*/, defaultOptions];
                                            return [4 /*yield*/, apiRef.list({
                                                    filter: { type: "folder" },
                                                })];
                                        case 1:
                                            response = _c.sent();
                                            return [2 /*return*/, defaultOptions.concat((_b = (_a = response === null || response === void 0 ? void 0 : response.result) === null || _a === void 0 ? void 0 : _a.objects) === null || _b === void 0 ? void 0 : _b.map(function (o) { return ({
                                                    value: o.id,
                                                    label: "/".concat(o.name),
                                                    caption: o.id,
                                                }); }))];
                                    }
                                });
                            }); },
                        },
                    },
                    /**
                        schema: yup
                            .string()
                            .test(
                            "is-path",
                            "Folder must be a valid path, starting with /",
                            (value) => {
                                return (value ?? "").startsWith("/");
                            }
                            )
                            .required(),
                            */
                },
            },
        },
        optional: {
            type: "grouping",
            label: "Advanced Settings",
            collaspable: true,
            defaultOpen: false,
            isHidden: function () { return hideFolderOptions; },
            fields: {
                tags: {
                    label: "Tags",
                    LabelProps: {
                        placement: "top",
                    },
                    FieldProps: {
                        type: "stringArray",
                        dedup: true,
                    },
                },
                metadata: {
                    label: "Metadata (JSON)",
                    LabelProps: {
                        placement: "top",
                    },
                    FieldProps: {
                        type: "json",
                    },
                    schema: yup
                        .mixed()
                        .test("is-object", "Metadata must be valid JSON", function (value) {
                        if (!value)
                            return true;
                        return typeof value === "object";
                    }),
                },
            },
        },
    });
};
